import * as React from 'react';

import EnterpriseHeaderFooterWrapper from 'bundles/unified-common/pageUtils/EnterpriseHeaderFooterWrapper';
import EnterprisePageGuard from 'bundles/unified-common/pageUtils/EnterprisePageGuard';
import EnterpriseUserStateCheckWrapper from 'bundles/unified-common/pageUtils/EnterpriseUserStateCheckWrapper';

type Props = {
  children: React.ReactNode;
  hideFooterTopBanner?: boolean;
};

/**
 * @description Provides the base functionality required for all enterprise pages.
 * Enables the enterprise header/footer with critical modal manager, basic program checks and critical user state checks.
 * With this backed by the EnterprisePageDataProvider, you can safely assume an enterprise page wrapped by this has sufficient
 * functionality for enterprise learners.
 */
const EnterprisePageTemplateWrapper = ({ children, hideFooterTopBanner }: Props) => {
  return (
    <EnterprisePageGuard>
      <EnterpriseHeaderFooterWrapper hideFooterTopBanner={hideFooterTopBanner}>
        <EnterpriseUserStateCheckWrapper>{children}</EnterpriseUserStateCheckWrapper>
      </EnterpriseHeaderFooterWrapper>
    </EnterprisePageGuard>
  );
};

export default EnterprisePageTemplateWrapper;
